// translations/blog.ts
export const translations = {
  en: {
    'blog.title': 'Blog',
    'blog.description': 'Stay updated with the latest e-invoice regulations and best practices',
    'blog.heading': 'Latest Updates &',
    'blog.headingHighlight': 'Guides',
    'blog.pageTitle': 'Blog - Latest Updates & Guides',
    'blog.metaDescription': 'Stay updated with the latest news, guides, and tips about invoice conversion, XRechnung, and e-invoicing compliance.',
    'blog.readMore': 'Read more',
    'blog.locale': 'en-US',
    'blog.posts.zugferd-vs-xrechnung.title': 'ZUGFeRD vs XRechnung: What\'s the Difference?',
    'blog.posts.zugferd-vs-xrechnung.date': 'December 2024',
    'blog.posts.eu-einvoicing-2025.title': 'EU E-Invoicing 2025: Everything You Need to Know',
    'blog.posts.eu-einvoicing-2025.date': 'December 2024',
    'blog.posts.xrechnung-guide-2025.title': 'XRechnung Guide 2025: Complete Documentation',
    'blog.posts.xrechnung-guide-2025.date': 'December 2024',
  },
  de: {
    'blog.title': 'Blog',
    'blog.description': 'Bleiben Sie auf dem Laufenden über die neuesten E-Rechnungsvorschriften und Best Practices',
    'blog.heading': 'Neueste Updates &',
    'blog.headingHighlight': 'Anleitungen',
    'blog.pageTitle': 'Blog - Neueste Updates & Anleitungen',
    'blog.metaDescription': 'Bleiben Sie auf dem Laufenden mit den neuesten Nachrichten, Anleitungen und Tipps zu Rechnungskonvertierung, XRechnung und E-Rechnungs-Compliance.',
    'blog.readMore': 'Weiterlesen',
    'blog.locale': 'de-DE',
    'blog.posts.zugferd-vs-xrechnung.title': 'ZUGFeRD vs XRechnung: Was ist der Unterschied?',
    'blog.posts.zugferd-vs-xrechnung.date': 'Dezember 2024',
    'blog.posts.eu-einvoicing-2025.title': 'EU E-Rechnung 2025: Alles was Sie wissen müssen',
    'blog.posts.eu-einvoicing-2025.date': 'Dezember 2024',
    'blog.posts.xrechnung-guide-2025.title': 'XRechnung Leitfaden 2025: Vollständige Dokumentation',
    'blog.posts.xrechnung-guide-2025.date': 'Dezember 2024',
  },
};